import React, { useEffect, useState } from "react";
import TransactionTable from "./TransactionTable";
import SaleTable from "./SaleTable";
import {
  myTransactionRequest,
  myTransactionRequestUpdpated,
} from "../../utils/transform.js";
import ErrorModal from "../common/ErrorModal.jsx";
import { createTransaction } from "../../services/transactionService.js";
import SuccessModal from "../common/SuccessModal.jsx";
import { sideTx } from "./components/Init.js";

function ReceiveGiven({
  customer,
  serialNumber,
  date,
  time,
  resetSerialNumber,
}) {
  const [receiveTx, setReceiveTx] = useState(sideTx("receive"));
  const [givenTx, setGivenTx] = useState(sideTx("given"));

  const [errors, setErrors] = useState([]);
  const [loading, setLoading] = useState(false);

  const [sucessMessage, setSuccessMessage] = useState(null);

  const header = {
    serialNo: serialNumber,
    date: date || new Date().toLocaleDateString(),
    partyName: customer.customerName || "Please Select a Customer",
    time: time || new Date().toLocaleTimeString(),
  };
  const resetStates = () => {
    resetSerialNumber();
    setReceiveTx(sideTx("receive"));
    setGivenTx(sideTx("given"));
  };

  const handleSubmit = async () => {
    if (!customer.customerId) {
      return setErrors(["Please select a customer before submitting."]);
    }
    const response = myTransactionRequestUpdpated({
      customerId: customer.customerId,
      serialNumber,
      receiveTx,
      givenTx,
      note: "Receive/Given transaction from SalePoint",
    });

    console.log("Transformed Transaction Data:", response);

    if (response.success) {
      // return alert("Transaction Data:", response);
      const data = response.data;
      // Adding transaction date/time to the data being sent to the backend
      const dateTime = header.date + " " + header.time;
      const transactionDate = new Date(dateTime);
      data.transactionDate = transactionDate;

      try {
        setLoading(true);
        const response = await createTransaction(data);
        if (response.success) {
          setSuccessMessage("Transaction created successfully!");
          setErrors([]);
        } else {
          setErrors(response.errors || ["Failed to create transaction."]);
        }
      } catch (err) {
        // console.log("Error submitting transaction:", err);
        console.log("Error message:", err.message);
        const errors = err.response?.data?.errors ||
          err.message || ["An unexpected error occurred."];
        setErrors(errors);
      } finally {
        setLoading(false);
      }
    } else {
      setErrors(response.errors);
    }
  };

  return (
    <>
      <div className="main section-sp">
        {/* RECEIVE */}
        <TransactionTable
          type={"receive"}
          tx={receiveTx}
          setTx={setReceiveTx}
          seletectedCustomer={{ customer, serialNumber }}
        />
        {/* GIVEN */}
        <TransactionTable
          type={"given"}
          tx={givenTx}
          setTx={setGivenTx}
          seletectedCustomer={{ customer, serialNumber }}
        />
      </div>
      <SaleTable
        header={header}
        receive={receiveTx}
        given={givenTx}
        onSubmit={handleSubmit}
        onPrint={() => window.print()}
        loading={loading}
      />

      {/* Modal to show errors */}
      <ErrorModal
        show={errors.length > 0}
        errors={errors}
        onClose={() => setErrors([])}
      />

      <SuccessModal
        show={sucessMessage !== null}
        message={sucessMessage}
        onClose={() => {
          setSuccessMessage(null);
          resetStates();
          window.scrollTo({
            top: 0,
            behavior: "smooth",
          });
        }}
      />
    </>
  );
}

export default ReceiveGiven;
